import React from "react";

const PolicyShell = ({ title, children, testId }) => (
  <section className="py-16 sm:py-20" style={{ background: "var(--ps-cream)" }} data-testid={testId}>
    <div className="mx-auto max-w-3xl px-4 sm:px-6">
      <span className="ornament font-display text-sm sm:text-base uppercase tracking-[0.3em]">Documento legale</span>
      <h1 className="section-title mt-4 text-3xl sm:text-4xl lg:text-5xl">{title}</h1>
      <div className="mt-8 max-w-none text-[var(--ps-ink)] font-body leading-relaxed space-y-4 text-lg">
        {children}
      </div>
    </div>
  </section>
);

export const CookiePolicy = () => (
  <PolicyShell title="Cookie Policy" testId="cookie-policy-page">
    <p>
      La presente Cookie Policy descrive come <strong>Pizzeria Salviano</strong> (di seguito "il Sito") utilizza i cookie e le tecnologie
      analoghe durante la navigazione sul sito web <strong>www.scopriiltuosito.it</strong>. Ultimo aggiornamento: {new Date().getFullYear()}.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Cosa sono i cookie</h2>
    <p>
      I cookie sono piccoli file di testo che i siti visitati inviano al terminale dell'utente, dove vengono memorizzati per essere ritrasmessi
      agli stessi siti alla visita successiva. Servono a rendere il funzionamento del sito più efficiente e a fornire informazioni ai proprietari.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Tipologie di cookie utilizzati</h2>
    <p><strong>Cookie tecnici (necessari):</strong> sono indispensabili per il corretto funzionamento del sito. Consentono, ad esempio, di memorizzare
      la scelta dell'utente relativa al banner cookie. Non richiedono consenso preventivo.</p>
    <p><strong>Cookie statistici / analitici:</strong> il Sito non installa cookie analitici di profilazione. Eventuali strumenti di misurazione sono
      utilizzati solo in forma aggregata e anonima previa accettazione da parte dell'utente.</p>
    <p><strong>Cookie di profilazione o marketing:</strong> il Sito non installa cookie di profilazione o marketing di terze parti senza il consenso
      dell'utente.</p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Cookie di terze parti</h2>
    <p>
      Il Sito integra una mappa <strong>Google Maps</strong> (embed gratuito) nella pagina Contatti. La consultazione della mappa può comportare
      l'installazione di cookie da parte di Google. Per maggiori informazioni consulta la
      {" "}<a className="text-[var(--ps-red)] underline" href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">Cookie Policy di Google</a>.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Come gestire le preferenze</h2>
    <p>
      Puoi in qualsiasi momento modificare le tue preferenze cancellando i cookie dal tuo browser oppure agendo direttamente sulle relative
      impostazioni. Alla prima visita compare un banner tramite il quale è possibile scegliere se accettare tutti i cookie o solo quelli necessari.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Titolare del trattamento</h2>
    <p>
      Pizzeria Salviano — Via Costanza 12/14, 57128 Livorno (LI). Telefono: 0586 326286. Per qualsiasi richiesta relativa alla presente policy è
      possibile contattarci ai recapiti indicati nella pagina Contatti.
    </p>
  </PolicyShell>
);

export const PrivacyPolicy = () => (
  <PolicyShell title="Privacy Policy" testId="privacy-policy-page">
    <p>
      La presente informativa è resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) da <strong>Pizzeria Salviano</strong>, in qualità di
      Titolare del trattamento, per gli utenti che consultano il sito <strong>www.scopriiltuosito.it</strong>. Ultimo aggiornamento: {new Date().getFullYear()}.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Titolare del trattamento</h2>
    <p>Pizzeria Salviano — Via Costanza 12/14, 57128 Livorno (LI). Telefono: 0586 326286 · WhatsApp: 370 3640199.</p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Dati raccolti</h2>
    <p>Il Sito è di natura informativa e non richiede la creazione di account o l'invio di form. I dati raccolti possono limitarsi a:</p>
    <ul className="list-disc pl-6 space-y-1">
      <li>dati di navigazione (indirizzo IP, tipo di browser, pagine visitate) raccolti in forma aggregata per finalità statistiche;</li>
      <li>cookie tecnici necessari al funzionamento del sito e alla memorizzazione delle preferenze relative al banner cookie.</li>
    </ul>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Finalità e base giuridica</h2>
    <p>
      I dati vengono trattati esclusivamente per garantire il corretto funzionamento del sito, per motivi di sicurezza e per adempiere ad obblighi
      di legge. La base giuridica del trattamento è il legittimo interesse del Titolare e, ove richiesto, il consenso dell'utente.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Conservazione dei dati</h2>
    <p>
      I dati di navigazione sono conservati per il tempo strettamente necessario alle finalità indicate; i cookie tecnici hanno durata di sessione
      o comunque non superiore a 12 mesi.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Diritti dell'interessato</h2>
    <p>
      L'interessato può in qualsiasi momento esercitare i diritti previsti dagli artt. 15-22 del GDPR: accesso, rettifica, cancellazione, limitazione,
      opposizione, portabilità dei dati. Per esercitare tali diritti è sufficiente contattare il Titolare ai recapiti indicati.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Servizi di terze parti</h2>
    <p>
      Il sito integra la mappa di <strong>Google Maps</strong> nella pagina Contatti. L'eventuale interazione con la mappa comporta il trattamento
      dei dati da parte di Google secondo la relativa
      {" "}<a className="text-[var(--ps-red)] underline" href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </p>
    <h2 className="font-display text-2xl text-[var(--ps-red)] uppercase tracking-[0.08em] mt-8">Reclami</h2>
    <p>
      L'utente ha il diritto di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali (www.garanteprivacy.it) qualora ritenga
      che il trattamento dei propri dati violi la normativa vigente.
    </p>
  </PolicyShell>
);

export default CookiePolicy;
